import { render, staticRenderFns } from "./TcMonetary.vue?vue&type=template&id=38b3f57e&scoped=true"
import script from "./TcMonetary.vue?vue&type=script&lang=js"
export * from "./TcMonetary.vue?vue&type=script&lang=js"
import style0 from "./TcMonetary.vue?vue&type=style&index=0&id=38b3f57e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38b3f57e",
  null
  
)

export default component.exports